// Scripted demo connect popup.
//
// Plays "Signing in → Connected" and closes itself WITHOUT contacting any
// provider. It is not a real connection: use it only for demos, or as the
// fallback when a provider has no OAuth URL configured in this build.
//
// Previously this lived inline in ConnectIntegrationBlock, was hardcoded to
// Salesforce, and ran by DEFAULT — which told the agent an integration was
// connected when it was not. It is now opt-in via sg_copilot_mock_oauth = "1".
const MOCK_POPUP_MS = 2600;

export const openMockConnectPopup = ({ label = "", iconUrl = "", onDone }) => {
  const done = typeof onDone === "function" ? onDone : () => {};
  const left = Math.max(0, window.screen.width / 2 - 240);
  const top = Math.max(0, window.screen.height / 2 - 300);
  const popup = window.open(
    "",
    `${label} Login`,
    `width=480,height=600,left=${left},top=${top}`
  );

  if (!popup) {
    // Popup blocked: keep the demo moving anyway.
    done();
    return;
  }

  popup.document.write(`<!DOCTYPE html>
<html>
<head>
<title>Log in | ${label}</title>
<style>
  body { margin: 0; font-family: -apple-system, "Segoe UI", Helvetica, Arial, sans-serif; background: #f3f4f8; display: flex; align-items: center; justify-content: center; height: 100vh; }
  .card { background: #fff; border-radius: 12px; box-shadow: 0 8px 28px rgba(29,32,38,.12); padding: 40px 44px; text-align: center; width: 300px; }
  .card img { width: 72px; margin-bottom: 18px; }
  .spinner { width: 26px; height: 26px; border: 3px solid #eceeff; border-top-color: #0176d3; border-radius: 50%; margin: 0 auto 14px; animation: spin .8s linear infinite; }
  .check { display: none; width: 44px; height: 44px; border-radius: 50%; background: #e8f8ef; color: #29b969; font-size: 26px; line-height: 44px; margin: 0 auto 14px; }
  h3 { font-size: 15px; color: #1d2026; margin: 0 0 6px; }
  p { font-size: 12px; color: #6b7280; margin: 0; }
  .done .spinner { display: none; }
  .done .check { display: block; }
  @keyframes spin { to { transform: rotate(360deg); } }
</style>
</head>
<body>
  <div class="card" id="card">
    ${iconUrl ? `<img src="${iconUrl}" alt="${label}" />` : ""}
    <div class="spinner"></div>
    <div class="check">&#10003;</div>
    <h3 id="msg">Signing in to ${label}&hellip;</h3>
    <p id="sub">demo environment, no credentials needed</p>
  </div>
  <script>
    setTimeout(function () {
      document.getElementById("card").className = "card done";
      document.getElementById("msg").innerText = "Connected";
      document.getElementById("sub").innerText = "Returning to Salesgear\\u2026";
    }, 1400);
  </script>
</body>
</html>`);
  popup.document.close();

  setTimeout(() => {
    try {
      popup.close();
    } catch (e) {
      /* noop */
    }
    done();
  }, MOCK_POPUP_MS);
};

export default openMockConnectPopup;
